import { useEffect, useState } from "react"

// The browser's own connectivity flag, kept in sync with its online/offline events.
export default function useOnlineStatus() {
  const [isOnline, setIsOnline] = useState(() => navigator.onLine !== false)

  useEffect(() => {
    const goOnline = () => setIsOnline(true)
    const goOffline = () => setIsOnline(false)
    window.addEventListener("online", goOnline)
    window.addEventListener("offline", goOffline)
    return () => {
      window.removeEventListener("online", goOnline)
      window.removeEventListener("offline", goOffline)
    }
  }, [])

  return isOnline
}
